import { map } from 'rxjs';
import getUnixTime from 'date-fns/getUnixTime';
import { AGENT_API } from '../AgentAPI';
import { convertUnixToDate } from '@golden/utils';
export function createWalletService(api) {
    return {
        getTransactionRecords(payload) {
            const data = { ...payload };
            if (data.start_at)
                data.start_at = getUnixTime(data.start_at);
            if (data.end_at)
                data.end_at = getUnixTime(data.end_at);
            return api.fetch(AGENT_API.GET_AGENT_WALLETS_HISTORY, { data }).pipe(map((res) => ({
                ...res,
                data: res.data.map((item) => convertUnixToDate(item, 'created_at'))
            })));
        },
        getSummary(account) {
            return api.fetch(AGENT_API.GET_AGENT_WALLETS_SUMMARY, { config: { urlParams: { account } } });
        },
        getTransferRecords(payload) {
            const data = { ...payload };
            if (data.start_at)
                data.start_at = getUnixTime(data.start_at);
            if (data.end_at)
                data.end_at = getUnixTime(data.end_at);
            return api.fetch(AGENT_API.GET_AGENT_TRANSFER_HISTORY, { data }).pipe(map((res) => ({
                ...res,
                data: res.data.map((item) => convertUnixToDate(item, 'created_at'))
            })));
        },
        transfer(data) {
            return api.fetch(AGENT_API.POST_AGENT_WALLETS_TRANSFER, { data });
        },
        getDepositMethods() {
            return api.fetch(AGENT_API.GET_AGENT_WALLETS_DEPOSIT_METHODS);
        },
        getDepositFee(data) {
            return api.fetch(AGENT_API.GET_AGENT_WALLETS_DEPOSIT_FEE, { data });
        },
        deposit(data) {
            return api.fetch(AGENT_API.POST_AGENT_WALLETS_DEPOSITS, { data }).pipe(map((res) => convertUnixToDate(res, 'expired_at')));
        },
        getDepositResult(id) {
            return api.fetch(AGENT_API.GET_AGENT_WALLETS_DEPOSIT_RESULT, { config: { urlParams: { id } } }).pipe(map((res) => convertUnixToDate(res, 'expired_at')));
        },
        getDepositRecords(payload) {
            const data = { ...payload };
            if (data.start_at)
                data.start_at = getUnixTime(data.start_at);
            if (data.end_at)
                data.end_at = getUnixTime(data.end_at);
            return api.fetch(AGENT_API.GET_AGENT_WALLETS_DEPOSITS, { data }).pipe(map((res) => ({
                ...res,
                data: res.data.map((item) => convertUnixToDate(item, 'created_at', 'expired_at'))
            })));
        },
        getDownloadLinks(slug) {
            return api.fetch(AGENT_API.GET_AGENT_DEPOSIT_DOWNLOAD_LINK, { data: { slug } });
        },
        getDepositRematch(data) {
            return api.fetch(AGENT_API.POST_REMATCH_DEPOSIT, { data });
        },
        getAccountAutoComplete(pattern) {
            return api.fetch(AGENT_API.GET_AGENT_WALLETS_USER_AUTO_COMPLETE, { data: { pattern } });
        }
    };
}
//# sourceMappingURL=WalletService.js.map